/* eslint-disable max-lines-per-function */
import "./contactus-late-order.scss";

const toggleOrderInfo = () => {
  const $toggles = document.querySelectorAll(".js-late-order-toggle-order-info");

  $toggles.forEach($element => {
    const $toggle = $element;
    $toggle.addEventListener("click", () => {
      $toggle.classList.toggle("show-info");
      $toggle.ariaExpanded = !($toggle.ariaExpanded === "true");
    });
  });
};

const validateShipmentsSelection = () => {
  const $checkboxes = document.querySelectorAll(".js-late-order-shipments-option");
  const $customOrderTextarea = document.querySelector(".js-late-order-custom-order");

  const updateRequiredState = () => {
    const hasCustomText = $customOrderTextarea.value.trim() !== "";
    const hasSelectedCheckbox = Array.from($checkboxes).some(checkbox => checkbox.checked);
    const shouldRequireCheckbox = !hasCustomText && !hasSelectedCheckbox;

    $checkboxes.forEach(checkbox => {
      if (shouldRequireCheckbox) {
        checkbox.setAttribute("required", "required");
      } else {
        checkbox.removeAttribute("required");
      }
    });
  };

  $customOrderTextarea.addEventListener("input", () => {
    updateRequiredState();
  });

  $checkboxes.forEach(checkbox => {
    checkbox.addEventListener("change", () => {
      updateRequiredState();
    });
  });
};

export default () => {
  toggleOrderInfo();
  validateShipmentsSelection();
};
